"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AppEditor;
const React = __importStar(require("react"));
const Editor_1 = __importDefault(require("./editor/Editor"));
const examples_1 = __importDefault(require("./examples"));
const hooks_1 = require("./hooks");
function AppEditor() {
    const canvasRef = React.useRef(null);
    const debuggerElement = React.createRef();
    const [example, loadExample] = (0, hooks_1.useExamples)(examples_1.default);
    const [code, updateCode] = (0, hooks_1.useCode)("editor", !example);
    const debug = (0, hooks_1.useDebug)();
    const settings = React.useMemo(() => ({
    //TODO: se li lascio vuoti e quindi moltiplico per devicePixelRatio, il source dell'initScreen si vede male (croppato)
    // width: window.innerWidth,
    // height: window.innerHeight,
    // width: 10,
    // height: 10,
    }), []);
    const [synth, error, clearError, update] = (0, hooks_1.useGydra)(canvasRef, (example === null || example === void 0 ? void 0 : example.code) || code, settings, updateCode);
    React.useEffect(() => {
        if (debug && synth && debuggerElement.current) {
            synth.debugger(debuggerElement.current);
            return () => {
                synth.debugger();
            };
        }
    }, [debug, synth, debuggerElement]);
    const exampleKey = example === null || example === void 0 ? void 0 : example.key;
    function closeExamples() {
        // get base64 code and go to /?code=base64
        if (example) {
            const encoded = btoa(unescape(encodeURIComponent(example.code)));
            const url = new URL(window.location.href);
            url.searchParams.set("code", encoded);
            url.searchParams.delete("example");
            window.location.href = url.toString();
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("canvas", { ref: canvasRef }),
        debug && React.createElement("div", { className: "debugger", ref: debuggerElement }),
        synth && React.createElement(Editor_1.default, { startValue: (example === null || example === void 0 ? void 0 : example.code) || code, error: error, closeError: clearError, onRun: update }),
        example && (React.createElement("div", { className: "examples" },
            React.createElement("select", { onChange: e => {
                    loadExample(e.target.value);
                }, defaultValue: exampleKey }, Object.keys(examples_1.default).map(groupOrKey => {
                const value = examples_1.default[groupOrKey];
                if (typeof value === "string") {
                    return React.createElement("option", { key: groupOrKey }, groupOrKey);
                }
                else {
                    return (React.createElement("optgroup", { label: groupOrKey, key: groupOrKey }, Object.keys(value).map(subKey => (React.createElement("option", { key: subKey, value: `${groupOrKey}.${subKey}` }, subKey)))));
                }
            })),
            React.createElement("div", { onClick: closeExamples }, "x")))));
}
